
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CarAccidents from "../pages/car-accidents/page";
import WorkplaceInjuries from "../pages/workplace-injuries/page";
import MedicalMalpractice from "../pages/medical-malpractice/page";
import SlipAndFall from "../pages/slip-and-fall/page";
import WrongfulDeath from "../pages/wrongful-death/page";
import DogBite from "../pages/dog-bite/page";
import Immigration from "../pages/immigration/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/car-accidents",
    element: <CarAccidents />,
  },
  {
    path: "/workplace-injuries",
    element: <WorkplaceInjuries />,
  },
  {
    path: "/medical-malpractice",
    element: <MedicalMalpractice />,
  },
  {
    path: "/slip-and-fall",
    element: <SlipAndFall />,
  },
  {
    path: "/wrongful-death",
    element: <WrongfulDeath />,
  },
  {
    path: "/dog-bite",
    element: <DogBite />,
  },
  {
    path: "/immigration",
    element: <Immigration />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
